var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPeople = function SvgPeople(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 68,
    viewBox: "0 0 95 68",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-innenstadtbesucher") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "Created with Sketch.") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#183E62",
    strokeWidth: 2,
    d: "M28.5 34C37.62 34 45 26.62 45 17.5S37.62 1 28.5 1 12 8.38 12 17.5 19.38 34 28.5 34Zm11.7 5h-1.21c-3.034 1.458-6.403 2.333-9.99 2.333s-6.942-.875-9.99-2.333H17.8C8.525 39 1 46.525 1 55.8V60c0 3.865 3.135 7 7 7h42c3.865 0 7-3.135 7-7v-4.2C57 46.525 49.475 39 40.2 39ZM71 34c7.73 0 14-6.27 14-14S78.73 6 71 6s-14 6.27-14 14 6.27 14 14 14Zm7.285 4h-.533c-1.95.72-4.013 1.2-6.202 1.2S67.3 38.72 65.35 38h-.534c-2.862 0-5.5.885-7.815 2.31a22.8 22.8 0 0 1 5.57 14.97v5.76c0 .33-.07.645-.084.96h24.78C90.982 62 94 58.775 94 54.8 94 45.515 86.97 38 78.285 38Z"
  })));
};
export default SvgPeople;